import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress' // 引入nprogress插件
import userHome from '@/view/userInfo/UserInfoCenter'
import global_ from '@/components/Globle';//全局变量库
import Vuex from 'vuex'
import webSocket from "../utils/webSocket";
Vue.use(Vuex)


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: '法天眼',
      },
      component: resolve => require(['@/view/Home'], resolve),
    },
    /**用户登录**/
    {
      path: '/userLogin',
      name: 'userLogin',
      meta: {
        title: '用户登录',
      },
      component: resolve => require(['@/view/system/userLogin'], resolve)
    },
    /**用户登录**/
    {
      path: '/userRegister',
      name: 'userRegister',
      meta: {
        title: '用户注册',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/system/userRegister'], resolve)
    },
    /**下载APP**/
    {
      path: '/downloadApp',
      name: 'downloadApp',
      meta: {
        title: '下载APP',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/system/downloadApp'], resolve)
    },
    /**跳转律瀛网站**/
    {
      path: '/watchLvyingProd',
      name: 'watchLvyingProd',
      meta: {
        title: '跳转律瀛网站'
      },
      component: resolve => require(['@/view/system/watchLvyingProd'], resolve)
    },
    {
      path: '/userMerchantRegister',
      name: 'userMerchantRegister',
      meta: {
        title: '律师注册'
      },
      component: resolve => require(['@/view/system/userMerchantRegister'], resolve)
    },
    /**重新设置密码**/
    {
      path: '/resetPassword',
      name: 'resetPassword',
      meta: {
        title: '重新设置密码',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/system/resetPassword'], resolve)
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      meta: {
        title: '找回密码',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/system/forgetPwd'], resolve)
    },
    {
      path: '/forgetPwd/phoneGetBackPwd',
      name: 'phoneGetBackPwd',
      meta: {
        title: '手机找回密码',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/userInfo/phoneGetBackPwd'], resolve)
    },
    {
      path: '/forgetPwd/emailGetBackPwd',
      name: 'emailGetBackPwd',
      meta: {
        title: '邮箱找回密码',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/userInfo/emailGetBackPwd'], resolve)
    },
    {
      path: '/forgetPwd/receptEmailRedirect',
      name: 'receptEmailRedirect',
      meta: {
        title: '邮箱回调地址修改密码',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/userInfo/receptEmailRedirect'], resolve)
    },
    {
      path: '/forgetPwd/secretGetBackPwd',
      name: 'secretGetBackPwd',
      meta: {
        title: '密保找回密码',
        loginedDeny: 'yes'
      },
      component: resolve => require(['@/view/userInfo/secretGetBackPwd'], resolve)
    },
    {
      path: '/bindEmailConfirm',
      name: 'bindEmailConfirm',
      meta: {
        title: '绑定邮箱页面',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/userInfo/bindEmailConfirm'], resolve)
    },
    // 合作律师
    {
      path: '/lawyer',
      name: 'lawyer',
      meta: {
        title: '合作律师'
      },
      component: resolve => require(['@/view/Lawyer'], resolve)
    },
    {
      path: '/LawyerInfo',
      name: 'LawyerInfo',
      meta: {
        title: '合作律师',
      },
      component: resolve => require(['@/view/LawyerInfo'], resolve)
    },
    // 风险快报
    {
      path: '/Express',
      name: 'Express',
      meta: {
        title: '风险快报'
      },
      component: resolve => require(['@/view/express/Express'], resolve)
    },
    {
      path: '/ExpressDetail',
      name: 'ExpressDetail',
      meta: {
        title: '风险快报详情',
      },
      component: resolve => require(['@/view/express/ExpressDetail'], resolve)
    },
    {
      path: '/test',
      name: 'test',
      meta: {
        title: '智能体检',
      },
      component: resolve => require(['@/view/Test'], resolve)
    },
    {
      path: '/testOrg',
      name: 'testOrg',
      meta: {
        title: '机构智能体检',
      },
      component: resolve => require(['@/view/TestOrg'], resolve)
    },
    {
      path: '/hotTest',
      name: 'hotTest',
      meta: {
        title: '热门体检',
      },
      component: resolve => require(['@/view/hotTest'], resolve)
    },
    {
      path: '/freeTest',
      name: 'freeTest',
      meta: {
        title: '免费体检',
      },
      component: resolve => require(['@/view/freeTest'], resolve)
    },
    {
      path: '/testStart',
      name: 'testStart',
      meta: {
        title: '智能体检',
      },
      component: resolve => require(['@/view/TestStart'], resolve)
    },
    {
      path: '/mobile/testStartMobile',
      name: 'testStartMobile',
      meta: {
        title: '智能体检(移动端)',
      },
      component: resolve => require(['@/view/mobile/TestStartMobile'], resolve)
    },
    {
      path: '/testBeginPrepare',
      name: 'testBeginPrepare',
      meta: {
        title: '准备题库',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/testBeginPrepare'], resolve)
    },
    {
      path: '/mobile/testBeginPrepareMobile',
      name: 'testBeginPrepareMobile',
      meta: {
        title: '准备题库(移动端)',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/mobile/testBeginPrepareMobile'], resolve)
    },
    {
      path: '/testBegin',
      name: 'testBegin',
      meta: {
        title: '开始答题',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/testBegin'], resolve)
    },
    {
      path: '/mobile/testBeginMobile',
      name: 'testBeginMobile',
      meta: {
        title: '开始答题(移动端)',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/mobile/testBeginMobile'], resolve)
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: {
        title: '关于我们',
      },
      component: resolve => require(['@/view/AboutUs'], resolve)
    },
    {
      path: '/order/orderConfirm',
      name: 'orderConfirm',
      meta: {
        title: '预创建订单界面',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/orderInfo/orderConfirm'], resolve)
    },
    {
      path: '/order/orderSubmit',
      name: 'orderSubmit',
      meta: {
        title: '订单支付页面',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/orderInfo/orderSubmit'], resolve)
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      redirect: '/userInfo/userIndex',
      meta: {
        title: '个人中心',
        needLogin: 'yes'
      },
      component: userHome,
      children: [
        {
          path: 'userIndex',
          name: 'userIndex',
          meta: {
            title: '个人首页',
            needLogin: 'yes'
          },
          component: () => import('@/view/userInfo/userIndex')
        },
        {
          path: 'userCenter',
          name: 'userCenter',
          meta: {
            title: '个人信息',
            needLogin: 'yes'
          },
          component: () => import('@/view/userInfo/UserCenter')
        },
        {
          path: '/orderInfo',
          name: 'orderInfo',
          meta: {
            title: '我的订单',
            needLogin: 'yes'
          },
          component: () => import('@/view/orderInfo/myOrderInfo')
        },
        {
          path: 'userMerchant',
          name: 'userMerchant',
          meta: {
            title: '我是律师',
            needLogin: 'yes'
          },
          component: () => import('@/view/userInfo/userMerchant')
        },
        {
          path: 'myVip',
          name: 'myVip',
          meta: {
            title: '我的会员',
            needLogin: 'yes'
          },
          component: () => import('@/view/userInfo/myVip')
        },
        {
          path: 'userCoupon',
          name: 'userCoupon',
          meta: {
            title: '我的优惠券',
            needLogin: 'yes'
          },
          component: () => import('@/view/userInfo/userCoupon')
        },
        {
          path: 'myReport',
          name: 'myReport',
          meta: {
            title: '我的报告',
            needLogin: 'yes'
          },
          component: () => import('@/view/userInfo/myReport')
        },
        {
          path: 'myIntegral',
          name: 'myIntegral',
          meta: {
            title: '我的积分',
            needLogin: 'yes'
          },
          component: () => import('@/view/userInfo/myIntegral')
        }
      ]
    },
    {
      path: '/VipCenter',
      name: 'VipCenter',
      meta: {
        title: '会员中心',
        needLogin: 'yes'
      },
      component: () => import('@/view/userInfo/VipCenter')
    },
    {
      path: '/OpenVip',
      name: 'OpenVip',
      meta: {
        title: '会员中心',
        needLogin: 'yes'
      },
      component: () => import('@/view/userInfo/OpenVip')
    },
    {
      path: '/WholeSearch',
      name: 'WholeSearch',
      meta: {
        title: '搜索结果'
      },
      component: resolve => require(['@/view/WholeSearch'], resolve)
    },
    {
      path: '/common/aliPayReturn',
      name: 'aliPayReturn',
      meta: {
        title: '支付宝支付成功返回页面',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/system/aliPayReturn'], resolve)
    },
    {
      path: '/reportShowPage',
      name: 'reportShowPage',
      meta: {
        title: '查看报告信息',
        needLogin: 'yes'
      },
      component: resolve => require(['@/view/orderInfo/reportShowPage'], resolve)
    },
    {
      path: '/useReport',
      name: 'useReport',
      meta: {
        title: '跳转APP'
      },
      component: resolve => require(['@/view/system/useReport'], resolve)
    },
    {
      path: '/mobile/downloadReport',
      name: 'downloadReport',
      meta: {
        title: '下载报告'
      },
      component: resolve => require(['@/view/mobile/downloadReport'], resolve)
    },
    {
      path: '*',
      name: '404',
      meta: {
        title: '404',
      },
      component: resolve => require(['@/view/404'], resolve)
    }
  ]
});

// 路由拦截
router.beforeEach((to, form, next) => {
  NProgress.start();
  // 监听路由状态动态修改网站标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if(to.meta.needLogin) {
    if(localStorage.getItem('userToken') && localStorage.getItem('userToken') !== 'null'
      &&  localStorage.getItem('userToken') !== 'undefined'){
      next();
      webSocket.dispatch('getWebsocket',localStorage.getItem("userId"));
      return false;
    }else{
      next({
        path: '/userLogin',
        query: { redirect: global_.urlBase + to.fullPath }
      });
      return false;
    }
  }
  if(to.meta.loginedDeny){
    if(localStorage.getItem('userToken') && localStorage.getItem('userToken') !== 'null'
      &&  localStorage.getItem('userToken') !== 'undefined') {
      next({
        path: '/',
      });
      return false;
    }
  }
  // 置顶
  // window.scrollTo(0, 0);

  next();
});

router.afterEach(() => {
  NProgress.done()
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js